import script from "./TimeseriesWidget.vue?vue&type=script&setup=true&lang=js"
export * from "./TimeseriesWidget.vue?vue&type=script&setup=true&lang=js"

import "./TimeseriesWidget.vue?vue&type=style&index=0&id=565e6cf0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-565e6cf0"]])

export default __exports__